export default class AccountNames {
  static ACCOUNT_PAYABLE = "Account Payable";

  static ACCOUNT_RECEIVABLE = "Account Receivable";
}
